<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2>Counselling Observation Details</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="container-fluid">
    <div class="row">
      <!-- Left Column -->
      <div class="col-md-6">
        <mat-list role="list">
          <mat-list-item role="listitem">
            <div class="d-flex w-100">
              <div class="item-label">Counsellor:</div>
              <div class="item-value">{{ Data.counsellor }}</div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item role="listitem">
            <div class="d-flex w-100">
              <div class="item-label">Observed By:</div>
              <div class="item-value">{{ Data.observedBy }}</div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item role="listitem">
            <div class="d-flex w-100">
              <div class="item-label">Date:</div>
              <div class="item-value">{{ displayDate(Data.sessionDate) }}</div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>

      <!-- Right Column -->
      <div class="col-md-6">
        <mat-list role="list">
          <mat-list-item role="listitem">
            <div class="d-flex w-100">
              <div class="item-label">Skills:</div>
              <div class="item-value">{{ Data.counsellingSkills }}</div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item role="listitem">
            <div class="d-flex w-100">
              <div class="item-label">Interventions:</div>
              <div class="item-value">{{ Data.interventions }}</div>
            </div>
          </mat-list-item>
          <mat-divider></mat-divider>
          <mat-list-item role="listitem">
            <div class="d-flex w-100">
              <div class="item-label">Understanding:</div>
              <div class="item-value">{{ Data.understandingOfProblem }}</div>
            </div>
          </mat-list-item>
        </mat-list>
      </div>
    </div>

    <!-- Full-width sections -->
    <div class="row mt-3">
      <div class="col-12">
        <h3 class="section-title">Home Program</h3>
        <p class="section-content">{{ Data.homeProgram }}</p>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-12">
        <h3 class="section-title">Feedback</h3>
        <p class="section-content">{{ Data.feedback }}</p>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="warn">Close</button>
</mat-dialog-actions>
